export default __webpack_public_path__ + "static/media/support-team-karl.560ae357.png";